module.exports = __webpack_public_path__ + "img/style13.e8568bbb.png";